import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState } from '@root/app-state.module';
import { Observable } from 'rxjs';
import { selectNumberOfAllSelectedLayers } from '@store/map-layers.selector';
import { MAX_SELECTED_MAP_LAYERS } from '@root/search/models/map.constants';

@Component({
  selector: 'rlst-map-layers-info-footer',
  templateUrl: './map-layers-info-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class MapLayersInfoFooterComponent implements OnInit {
  public numberOfAllSelectedLayers$: Observable<number>;
  public readonly MAX_SELECTED_MAP_LAYERS: number = MAX_SELECTED_MAP_LAYERS;

  constructor(
    private readonly store$: Store<AppState>) {
  }

  ngOnInit() {
    this.numberOfAllSelectedLayers$ = this.store$.pipe(
      select(selectNumberOfAllSelectedLayers)
    );
  }
}
